import { useState } from 'react';
import PhotoPlaceholder from '../components/photo-placeholder';
import Lightbox from '../components/lightbox';
import { INSTALACIONES } from '../data/content';
import { eyebrow, h1, pageWrap } from '../lib/styles';

const Facilities = () => {
  const [light, setLight] = useState(null);

  return (
    <div style={pageWrap}>
      <div style={{ maxWidth: '58ch' }}>
        <span style={eyebrow}>Instalaciones</span>
        <h1 style={h1}>Bienvenida a Zenya</h1>
        <p
          style={{ fontSize: 'clamp(16px, 1.8vw, 19px)', lineHeight: 1.8, color: 'var(--ink-700)', margin: '0 0 14px' }}
        >
          Diseñamos el local pensando en cómo se siente estar aquí una hora: la luz cálida, el orden de cada estación,
          el olor limpio, la música que no interrumpe. Nada está de más.
        </p>
        <p style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--ink-600)', margin: '0 0 4vw' }}>
          Si es tu primera visita, así se ve el lugar antes de que llegues.
        </p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))', gap: 16 }}>
        {INSTALACIONES.map((f) => (
          <PhotoPlaceholder
            key={f.label}
            label={f.label}
            nota={f.nota}
            ratio={f.ratio}
            onClick={() => setLight(f.label)}
            style={{ gridColumn: `span ${f.span}` }}
          />
        ))}
      </div>
      <Lightbox label={light} onClose={() => setLight(null)} />
    </div>
  );
};

export default Facilities;
